import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { OptimizerObjective, OptimizerRequest, OptimizerResultDto, OptimizerVariable } from '@trajectory/contracts';
import { apiFetch } from '@/lib/api';

export interface StartOptimizerInput {
  missionId: string;
  objective: OptimizerObjective;
  variables: OptimizerVariable[];
}

export function useStartOptimizer() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: StartOptimizerInput) => {
      const body: Partial<OptimizerRequest> = {
        missionId: input.missionId,
        objective: input.objective,
        variables: input.variables,
      };
      return apiFetch<OptimizerResultDto>('/optimize', { method: 'POST', body: JSON.stringify(body) });
    },
    onSuccess: (result) => queryClient.setQueryData(['optimizer', result.id], result),
  });
}

const ACTIVE_STATUSES = new Set(['queued', 'running']);

export function useOptimizerJob(id: string | null) {
  return useQuery({
    queryKey: ['optimizer', id],
    queryFn: () => apiFetch<OptimizerResultDto>(`/optimize/${id}`),
    enabled: id !== null,
    refetchInterval: (query) => (query.state.data && ACTIVE_STATUSES.has(query.state.data.status) ? 500 : false),
  });
}
